// modal.service.ts
import {Injectable, Type} from '@angular/core';
import {BehaviorSubject, debounceTime, Observable, Subject} from 'rxjs';
import {UrlHistoryService} from './url.history.service';

export interface ModalConfig<T = any> {
  component: Type<any>;
  data?: T;
  closeOnBackdrop?: boolean;
  closeSubject?: Subject<any>;
}

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private modalStack = new BehaviorSubject<ModalConfig[]>([]);
  private currentStack: ModalConfig[] = [];

  constructor(private urlHistory: UrlHistoryService) {
    this.urlHistory.browserBack$.pipe(
      debounceTime(50)  // Small buffer for synchronization
    ).subscribe(() => {
      if (this.currentStack.length !== 0) {
        this.close();
      }
    });
  }

  show<T>(component: Type<any>, config?: Partial<ModalConfig<T>>) {
    console.log('Show modal called');
    const closeSubject = new Subject<any>();
    const modalConfig = {
      component,
      closeOnBackdrop: true,
      closeSubject,
      ...config
    };
    this.currentStack = [...this.currentStack, modalConfig];
    this.modalStack.next(this.currentStack);
    console.log('New stack:', this.currentStack);
    return closeSubject.asObservable();
  }

  close(value?: any) {
    console.log('Close modal called');
    if (this.currentStack.length === 0) {
      console.warn('No modal to close');
      return;
    }

    const modalToClose = this.currentStack.pop();
    this.modalStack.next(this.currentStack);
    console.log('Stack after close:', this.currentStack);

    if (modalToClose?.closeSubject) {
      modalToClose.closeSubject.next(value);
      modalToClose.closeSubject.complete();
    }
  }

  get modals$() {
    return this.modalStack.asObservable();
  }
}
